var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgArtCarouselHouse = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h60v60H0V0z",
    id: "gic0hnseia"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    xlinkHref: "#gic0hnseia"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h60v60H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EDD296",
    d: "M53 16.156v23.412L26.059 54.955V31.66"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#63ABB7",
    d: "m7.022 20.692 19.043 11.024L52.91 16.201 34.146 5.335 33.579 5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DDB05F",
    d: "m16.375 23.57 17.315-9.995 9.605 5.572-17.269 10.132z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E5CA95",
    d: "m10.74 20.449 5.809 3.37 17.242-9.995V7.11"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#568E9B",
    d: "M33.787 7.135v6.647l9.37 5.42 5.623-3.226"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E8297",
    d: "M7 20.763v23.411L26.073 55V31.704"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DDB05F",
    d: "M17.458 34.705v7.867l2.28-1.19V35.79"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D8A960",
    d: "m19.084 41.814 6.2-3.34 8.605 4.956-6.51 3.273"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#036177",
    d: "m17.435 42.56 7.751 4.386 1.938-1.115-7.548-4.347"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#419AA8",
    d: "m26.105 45.245-2.067 1.042 2.063 1.18 1.938-1.103z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "m19.618 41.443-.093-5.767 5.862 2.943zM26.057 38.99l11.425-6.538v13.31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.684 33.337v7.407c0 1.263-.032 2.538-.034 3.814l1.812 1.074V32.321l-1.778 1.018v-.002z",
    fill: "#036177"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DDB05F",
    d: "M28.047 46.222v6.592l11.169-6.257-5.47-3.015z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EDD296",
    d: "m37.466 45.592-10.761 5.843v1.004l10.775-5.888"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C7792",
    d: "m28.009 51.711.856.6v1.073l-.818-.57"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DDB05F",
    d: "m28.865 53.384.905.505 11.211-6.426-.93-.505"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DEDEE0",
    d: "m35.684 33.337-1.937 10.205 1.903 1.016"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C7792",
    d: "m48.153 32.692-6.811 4.246.004.7v.123l7.447-4.62"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DEDEE0",
    d: "M41.35 29.646v7.38l6.926-4.223v-7.338"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#036177",
    d: "M48.276 25.461v7.367l.527.338v-8.042"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArtCarouselHouse);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/art-carousel-house.0822085cc7ca7eeafb8a05a8e5d5ffa8.svg";